function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import { useTranslation } from "react-i18next";
import { default as ReactAsync } from "react-select/async";
import { components } from "react-select";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import SearchIcon from "@mui/icons-material/Search";
import UserAvatar from "../../../../../components/mui/material/UserAvatar";
import { useThemeContext } from "../../../../../contexts/ThemeContext";
import { brandPrimary } from "../../../../../constants";
var tKey = "features.Chat.Actions.AddGroupMembersDialog.UsersAsync";
var customControlStyles = function customControlStyles(theme) {
  return {
    boxShadow: "none",
    border: "none",
    borderBottom: "1px solid ".concat(theme === "dark" ? "rgb(51, 54, 57)" : "rgba(0, 0, 0, 0.23)"),
    borderRadius: 0,
    backgroundColor: "transparent",
    "&:hover": {
      borderColor: theme === "dark" ? "rgb(51, 54, 57)" : "rgba(0, 0, 0, 0.23)"
    }
  };
};
var customValueContainerStyles = {
  // padding: "16px 24px",
};
var customInputStyles = {
  color: "inherit"
};
var customDropdownIndicatorStyle = {
  color: brandPrimary
  // padding: "16px 24px",
};
var customOptionStyle = function customOptionStyle(base, state, theme) {
  return {
    color: "inherit",
    backgroundColor: state.isFocused || state.isSelected ? "rgb(255, 255, 255, 0.08)" : base.backgroundColor,
    borderBottom: "1px solid ".concat(theme === "dark" ? "rgb(51, 54, 57)" : "rgba(0, 0, 0, 0.23)")
  };
};

// const customMultiValueStyle = {
//   backgroundColor: "rgba(255, 255, 255, 0.12)",
//   padding: 2,
//   borderRadius: 20,
// };

var customMenuStyle = {
  backgroundColor: "trasparent",
  margin: 0,
  padding: 0,
  borderRadius: 0
};
var customMenuListStyle = {
  margin: 0,
  padding: 0,
  maxHeight: 400
};
var customStyle = function customStyle(theme) {
  return {
    control: function control(base, state) {
      return _objectSpread(_objectSpread({}, base), customControlStyles(theme));
    },
    valueContainer: function valueContainer(base, state) {
      return _objectSpread(_objectSpread({}, base), customValueContainerStyles);
    },
    input: function input(base, state) {
      return _objectSpread(_objectSpread({}, base), customInputStyles);
    },
    dropdownIndicator: function dropdownIndicator(base, state) {
      return _objectSpread(_objectSpread({}, base), customDropdownIndicatorStyle);
    },
    option: function option(base, state) {
      return _objectSpread(_objectSpread({}, base), customOptionStyle(base, state, theme));
    },
    // multiValue: (base, state) => ({
    //   ...base,
    //   ...customMultiValueStyle,
    // }),
    menu: function menu(base, state) {
      return _objectSpread(_objectSpread({}, base), customMenuStyle);
    },
    menuList: function menuList(base, state) {
      return _objectSpread(_objectSpread({}, base), customMenuListStyle);
    }
  };
};
var CustomDropdownIndicator = function CustomDropdownIndicator(props) {
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement(SearchIcon, null));
};
var CustomOption = function CustomOption(props) {
  return /*#__PURE__*/React.createElement(components.Option, props, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0,
    sx: {
      pr: 1
    }
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    size: "md",
    user: props.data
  })), /*#__PURE__*/React.createElement(Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontWeight: 600
    }
  }, props.data.fullName), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "rgb(113, 118, 123)"
    }
  }, "@", props.data.username))));
};
var CustomMultiValue = function CustomMultiValue(props) {
  return /*#__PURE__*/React.createElement(components.MultiValueContainer, props, /*#__PURE__*/React.createElement(Chip, {
    avatar: /*#__PURE__*/React.createElement(UserAvatar, {
      size: "xs",
      user: props.data
    }),
    label: "@".concat(props.data.username),
    onDelete: props.removeProps.onClick
  }));
};
function Async(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useThemeContext = useThemeContext(),
    theme = _useThemeContext.theme;
  function handleNoOptionsMessage(_ref) {
    var inputValue = _ref.inputValue;
    return inputValue === "" ? t("".concat(tKey, ".placeholder")) : t("".concat(tKey, ".noOptions"), {
      inputValue: inputValue
    });
  }
  return /*#__PURE__*/React.createElement(ReactAsync, _extends({
    isMulti: true,
    isClearable: true,
    loadingMessage: function loadingMessage() {
      return t("".concat(tKey, ".loadingMessage"));
    },
    noOptionsMessage: handleNoOptionsMessage,
    placeholder: t("".concat(tKey, ".placeholder"))
    // menuPortalTarget={document.body}
    // menuPosition="fixed"
  }, props, {
    components: _objectSpread({
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: CustomDropdownIndicator,
      Option: CustomOption,
      MultiValue: CustomMultiValue
    }, props.components),
    styles: _objectSpread(_objectSpread({}, customStyle(theme)), props.styles)
  }));
}
export default Async;